import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CapacitorHttp } from "@capacitor/core";
import topics from "../data/topics.json";
import { getFirestore, collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { auth } from "../firebase/firebase";

const startDate = new Date("2025-03-03");

const DayCalendar = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [todayTopic, setTodayTopic] = useState(null);
  const [dayIndex, setDayIndex] = useState(null);
  const [chatLogs, setChatLogs] = useState([]);

  useEffect(() => {
    const selectedDate = searchParams.get("date");
    if (selectedDate) {
      const dateObj = new Date(selectedDate);
      const diffTime = dateObj.getTime() - startDate.getTime();
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays >= 0 && diffDays < topics.length) {
        setDayIndex(diffDays);
        setTodayTopic(topics[diffDays]);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    const fetchChatLogs = async () => {
      const selectedDate = searchParams.get("date");
      const childId = localStorage.getItem("child_id");
      if (!childId || !selectedDate) return;

      if (window.Capacitor?.isNativePlatform?.()) {
        try {
          const url = `https://firestore.googleapis.com/v1/projects/gigitherobot-4550d/databases/(default)/documents/chat_logs/${childId}/history?pageSize=100`;
          const response = await CapacitorHttp.get({ url });
          if (response.status !== 200) {
            console.error("❌ Lỗi lấy dữ liệu Capacitor:", response);
            return;
          }

          const allLogs = (response.data.documents || []).map((doc) => {
            const fields = doc.fields || {};
            const user = fields.user?.stringValue || "";
            const reply = fields.reply?.stringValue || "";
            const date = fields.date?.stringValue || "";
            const time = fields.time?.timestampValue || "";
            return { user, reply, date, time };
          });

          const filteredLogs = allLogs
            .filter((log) => log.date === selectedDate)
            .sort((a, b) => new Date(a.time) - new Date(b.time));

          setChatLogs(filteredLogs);
        } catch (err) {
          console.error("❌ Lỗi Capacitor:", err);
        }
      } else {
        try {
          const db = getFirestore();
          const q = query(
            collection(db, "chat_logs", childId, "history"),
            where("date", "==", selectedDate),
            orderBy("time")
          );
          const snapshot = await getDocs(q);
          const logs = snapshot.docs.map((doc) => doc.data());

          const sortedLogs = logs.sort((a, b) => new Date(a.time.toDate()) - new Date(b.time.toDate()));

          setChatLogs(sortedLogs);
        } catch (err) {
          console.error("❌ Lỗi SDK Firebase:", err);
        }
      }
    };

    fetchChatLogs();
  }, [searchParams]);

  if (!todayTopic) {
    return (
      <div className="p-10 text-center text-dark-text">
        Không tìm thấy bài học cho ngày này. Hãy quay lại lịch.
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-light-primary-key-background flex flex-col items-center px-4 pt-6 pb-[calc(env(safe-area-inset-bottom)+100px)] overflow-y-auto">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-6 flex flex-col gap-4">
        <h1 className="text-xl font-semibold text-dark-pink text-center">
          Bài học ngày {dayIndex + 1}
        </h1>
        <div className="text-center text-lg">{todayTopic.Topic}</div>
      </div>

      {chatLogs.length > 0 && (
        <div className="w-full max-w-md mt-6 bg-white rounded-xl shadow p-4">
          <h2 className="text-lg font-semibold text-pink-500 mb-2">
            🗣️ Lịch sử trò chuyện
          </h2>
          <ul className="space-y-2 text-left">
            {chatLogs.map((log, index) => (
              <li key={index} className="bg-pink-50 rounded p-2 text-sm leading-relaxed">
                👧 <strong>Bé:</strong> {log.user}<br />
                🤖 <strong>Gigi:</strong> {log.reply || log.assistant}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Nút quay về */}
      <button
        onClick={() => navigate("/41-home")}
        className="fixed bottom-6 bg-pink-500 hover:bg-pink-600 text-white text-sm font-semibold py-3 px-6 rounded-full shadow-md"
      >
        Quay về Trang chính
      </button>
    </div>
  );
};

export default DayCalendar;

